import { faArrowPointer, faBolt, faCircleX, faShieldCheck } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import '../styles/componentStyles/ColumnGrid.css';
import { colours } from '../../assets/colours';
import { worstAreaOfPain } from '../../shared/util/enum';

function ColumnGrid(props) {
  const { t } = useTranslation();
  const titleId = props.title?.replace(/\s+/g, '');
  const [values] = useState(props.data);
  const [severity, setSeverity] = useState({ text: '', color: '' });
  const [showLocations, setShowLocations] = useState(false);

  useEffect(() => {
    if (props.data && props.data[0].value.severity) {
      const value = Number(props.data[0].value.severity);
      if (value === 1) {
        setSeverity(() => ({ text: `${t('DW024')}`, color: colours.green }));
      } else if (value === 2) {
        setSeverity(() => ({ text: `${t('D218')}`, color: colours.yellow }));
      } else if (value === 3) {
        setSeverity(() => ({ text: `${t('D219')}`, color: colours.orange }));
      } else if (value === 4) {
        setSeverity(() => ({ text: `${t('D220')}`, color: colours.orange }));
      } else {
        setSeverity(() => ({ text: `${t('D221')}`, color: colours.red }));
      }
    }
  }, [props.data, t]);

  const findLocationById = (id) => {
    const location = worstAreaOfPain.find((item) => item.id === id);
    return location ? location.title : '';
  };

  return (
    <div
      className={`chart-container ${props.width}`}
      role="group"
      aria-labelledby={`${titleId}-column-grid-title`}
    >
      <div className="title-container">
        <h3 className="title" id={`${titleId}-column-grid-title`}>
          {props.title}
        </h3>
      </div>
      <div className="grid-container">
        {values.map((item, index) => {
          return (
            // Snapshot of assessment data without ids, stateless columns.
            // eslint-disable-next-line react/no-array-index-key
            <div className="column fs-exclude" key={index}>
              <div className="row">
                <div className="row-heading">{t('D015')}</div>
                <div>{findLocationById(item.value.primary_pain_location)}</div>
              </div>

              <div className="row">
                <div className="row-heading">{t('D016')}</div>
                <div style={{ color: colours['faded-rose'] }}>
                  {/* {showLocations && <div className="pain-tooltip"></div>}{" "} */}
                  <span className="icon_circle">
                    <FontAwesomeIcon icon={faArrowPointer} className="icon" />
                  </span>
                  {item.value.secondary_locations ? (
                    <div className="locations-container fs-mask">
                      <button
                        type="button"
                        className="locations transparent-button"
                        onClick={() => setShowLocations(!showLocations)}
                      >
                        {showLocations ? t('results.show.locations') : t('DW025')}
                      </button>
                      {showLocations && (
                        <div className="pain-tooltip">
                          {item.value.secondary_locations.map((location) => (
                            <div key={location}>{findLocationById(location)}</div>
                          ))}
                        </div>
                      )}{' '}
                    </div>
                  ) : (
                    <div> {t('D032')} </div>
                  )}
                </div>
              </div>

              <div className="row">
                <div className="row-heading">{t('D017')}</div>
                {item.value.severity && Number(item.value.severity) > 0 ? (
                  <div style={{ color: `${severity.color}` }}>
                    <span className="icon_circle">
                      <FontAwesomeIcon icon={faBolt} className="icon" />
                    </span>
                    {severity.text}
                  </div>
                ) : (
                  <div>-</div>
                )}
              </div>
              <div className="row">
                <div className="row-heading">{t('D018')}</div>
                {item.value.specialist_support === 'yes' &&
                  item.value.specialist_support !== '-' && (
                    <div style={{ color: colours.green }}>
                      <span className="icon_circle ">
                        <FontAwesomeIcon icon={faShieldCheck} className="icon" />
                      </span>
                      {t('T066')}
                    </div>
                  )}
                {item.value.specialist_support === 'no' &&
                  item.value.specialist_support !== '-' && (
                    <div style={{ color: colours.red }}>
                      <span className="icon_circle ">
                        <FontAwesomeIcon icon={faCircleX} className="icon" />
                      </span>
                      {t('T067')}
                    </div>
                  )}{' '}
              </div>

              <div className="row">
                <div className="row-heading">{t('D019')}</div>
                {item.value.activity_status === 'Active' && (
                  <div style={{ color: colours.green }}>
                    <span className="icon_circle">
                      <FontAwesomeIcon icon={faShieldCheck} className="icon" />
                    </span>
                    {t('R085')}
                  </div>
                )}

                {item.value.activity_status === 'Inactive' && (
                  <div style={{ color: colours.red }}>
                    <span className="icon_circle ">
                      <FontAwesomeIcon icon={faCircleX} className="icon" />
                    </span>
                    {t('R086')}
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default ColumnGrid;
